export default __webpack_public_path__ + "static/media/academic_advice.1f9c01c4.png";